// Fixed-timestep accumulator: physics runs at a constant rate, independent of
// the display refresh rate (60 Hz, 120 Hz ProMotion, or a stuttering frame).

export class FixedStep {
  private acc = 0;

  constructor(
    readonly dt: number,
    /** Cap on simulated time per frame, so a long stall doesn't cause a spiral of catch-up steps. */
    private readonly maxFrame = 0.1,
  ) {}

  /** Runs `step` as many times as needed for `frameDt`; returns the leftover fraction for interpolation. */
  advance(frameDt: number, step: (dt: number) => void): number {
    this.acc += Math.min(Math.max(frameDt, 0), this.maxFrame);
    while (this.acc >= this.dt) {
      step(this.dt);
      this.acc -= this.dt;
    }
    return this.acc / this.dt;
  }
}
